import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initMentoringGrowth(): void {
    const rings = document.querySelectorAll('.growth-ring');
    if (rings.length === 0) return;

    gsap.set(rings, { opacity: 0, scale: 0.5 });

    ScrollTrigger.create({
        trigger: '.growth-rings',
        start: 'top 80%',
        onEnter: () => {
            gsap.to(rings, {
                opacity: 0.5,
                scale: 1,
                stagger: 0.2,
                duration: 1,
                ease: 'elastic.out(1, 0.5)'
            });
        }
    });
}

export function initProgressionPath(): void {
    const items = document.querySelectorAll('.progression-item');
    if (items.length === 0) return;

    gsap.from(items, {
        opacity: 0,
        y: 40,
        stagger: 0.3,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
            trigger: '.progression-path',
            start: 'top 75%'
        }
    });
}
